import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import NumberFormat from 'react-number-format';
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import colors from '../../../../config/themeColors';
import GridItem from '../../../common/components/Drawer/GridItem';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: 'calc(100% - 32px)',
        marginLeft: '16px',
        marginRight: '16px',
    },
    center: {
        textAlign: 'center',
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    image: {
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: colors.white2,
        margin: '32px auto',
    },
    congratulation: {
        fontSize: '32px',
        lineHeight: 1.1,
    },
    congratulationDesc: {
        fontSize: '22px',
        lineHeight: 1.1,
    },
    congratulationDescSmaller: {
        fontSize: '14px',
        color: colors.brownishGrey,
        margin: '10px',
    },
    amount: {
        fontSize: '20px',
    },
    amountNumber: {
        color: colors.bloodOrange,
        fontSize: '32px',
    },
    detailsContainer: {
        width: 'calc(100% - 20px)',
        maxWidth: '600px',
        margin: '8px auto',
        borderRadius: '4px',
        backgroundColor: colors.white,
        boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
    },
    applicantNameContainer: {
        padding: '24px',
    },
    applicantDataContainer: {
        backgroundColor: colors.stepContent,
        paddingLeft: '24px',
        paddingBottom: '16px',
    },
    applicantName: {
        fontSize: '18px',
        color: colors.black,
    },
    applicantNameDesc: {
        fontSize: '12px',
        color: colors.warmGrey,
    },
});

function SoftCheckDecision(props) {
    return (props.isPending
        ? (
            <div className={props.classes.root}>
                <CircularProgress/>
            </div>
        )
        : (
            <div className={props.classes.root}>
                {props.decision === 'allow' &&
                <div>
                    <div className={props.classes.center}>
                        <div className={props.classes.image}>
                            &nbsp;
                        </div>
                        <Typography className={props.classes.congratulation}>
                            Congratulation!
                        </Typography>
                        <Typography className={props.classes.congratulationDesc}>
                            Your Decision in Principle is ready
                        </Typography>
                        <Typography className={props.classes.congratulationDescSmaller}>
                            Based on the information you provided we may be able to lend you
                        </Typography>
                        <Typography className={props.classes.amount}>
                            up to&nbsp;
                            <NumberFormat
                                className={props.classes.amountNumber}
                                value={props.maxLendAmount.amount}
                                displayType="text"
                                thousandSeparator
                                prefix="&pound;"
                            />
                        </Typography>
                    </div>
                    <div className={props.classes.detailsContainer}>
                        <Grid
                            container
                            spacing={0}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={6}
                            >
                                <div className={props.classes.applicantNameContainer}>
                                    <Typography className={props.classes.applicantName}>
                                        {props.applicant.name} {props.applicant.surname}
                                    </Typography>
                                    <Typography className={props.classes.applicantNameDesc}>
                                        Your name
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                            >
                                <div className={props.classes.applicantDataContainer}>
                                    <Grid
                                        className={props.classes.grid}
                                        container
                                        spacing={0}
                                    >
                                        <GridItem
                                            caption="Date of birth"
                                        >
                                            {props.applicant.dateOfBirth}
                                        </GridItem>
                                        <GridItem
                                            caption="City"
                                        >
                                            {props.applicant.address.city}
                                        </GridItem>
                                        <GridItem
                                            caption="Postal code"
                                        >
                                            {props.applicant.address.postalCode}
                                        </GridItem>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </div>
                }
                {props.decision === 'deny' &&
                <Typography>
                    Based on information you provided we are unable to lend you money.
                </Typography>
                }
            </div>
        ));
}

SoftCheckDecision.propTypes = {
    classes: PropTypes.object.isRequired,
    decision: PropTypes.string.isRequired,
    maxLendAmount: PropTypes.object.isRequired,
    isPending: PropTypes.bool.isRequired,
    applicant: PropTypes.object.isRequired,
};

export default withStyles(styles)(SoftCheckDecision);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/components/SoftCheckDecision.js